"use strict";

define('service/wootric',['appkit/service', 'moment', '../libs/wootric'], function (Service, moment, wootric) {
  var WootricService = Service.extend({
    events: {
      'authenticated': 'onAuthenticated'
    },
    onAuthenticated: function onAuthenticated(user) {
      var firstLoginDate = user.getFirstLogonDate();
      wootric.run({
        email: user.getPersonEmail(),
        created_at: moment(firstLoginDate).unix(),
        product_name: 'IRB',
        account_token: user.getWootricCode(),
        properties: {
          'Product Line': 'Research',
          'Product': 'Cayuse IRB'
        }
      });
    }
  });
  return WootricService;
});

